import { render, staticRenderFns } from "./myPoints.vue?vue&type=template&id=7bfd9504&scoped=true"
import script from "./myPoints.vue?vue&type=script&lang=js"
export * from "./myPoints.vue?vue&type=script&lang=js"
import style0 from "./myPoints.vue?vue&type=style&index=0&id=7bfd9504&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfd9504",
  null
  
)

export default component.exports